import { LogPageViewPayload, LogPageViewResult } from "constellation-sdk";
import { api } from "../../../../common/api/api";

class PageViewProviderService {
    public async logPageView(payload: LogPageViewPayload): Promise<LogPageViewResult> {
        return api.self.logPageView(payload)
    }
}

export const service = new PageViewProviderService();